import React, { Ref } from 'react';

import Flex from '@cobalt/react-flex';

import Radio from './Radio';
import { RadioGroupOptionType } from './types';

export interface RadioGroupProps {
  value: string;
  disabled?: boolean;
  options: Array<string | RadioGroupOptionType>;
  forwardedRef?: Ref<HTMLInputElement>;
  onChange: (value: string) => void;
}

export default function RadioGroup(props: RadioGroupProps) {
  const { value, disabled = false, options, onChange } = props;

  return (
    <Flex direction="column" gap={2}>
      {options.map((option) => {
        if (typeof option === 'string') {
          return (
            <Radio
              key={option}
              label={option}
              checked={value === option}
              disabled={disabled}
              onChange={() => onChange(option)}
            />
          );
        } else {
          return (
            <Radio
              key={option.value}
              label={option.label}
              checked={value === option.value}
              disabled={disabled || option.disabled}
              onChange={() => onChange(option.value)}
            />
          );
        }
      })}
    </Flex>
  );
}
